module.exports = __webpack_public_path__ + "fonts/inter-v3-latin-ext_latin-600.bd2c3f4.eot";